export const LOGIN_COMPANY_DISPLAY_NAME =
  process.env.REACT_APP_LOGIN_COMPANY_DISPLAY_NAME || 'Litvik Software Labs Private Limited';

const LOGIN_COMPANY_MATCH_TEXT =
  process.env.REACT_APP_LOGIN_COMPANY_NAME || 'litvik';

/** Static login card / brand logo — place file under frontend/public */
export const LOGIN_COMPANY_LOGO =
  process.env.REACT_APP_LOGIN_COMPANY_LOGO
  || `${process.env.PUBLIC_URL || ''}/litvik_logo.jpg`;

/** Header brand name — defaults to login company display name */
export const BRAND_NAME =
  process.env.REACT_APP_BRAND_NAME || LOGIN_COMPANY_DISPLAY_NAME;

/** Header brand logo — defaults to login company logo */
export const BRAND_LOGO =
  process.env.REACT_APP_BRAND_LOGO || LOGIN_COMPANY_LOGO;

export const BRAND_TAGLINE =
  process.env.REACT_APP_BRAND_TAGLINE || 'Ready Mix Concrete ERP';

/** Browser tab / app form title */
export const APP_TITLE =
  process.env.REACT_APP_APP_TITLE || 'Litvik RMC Pvt. Ltd.';

export function resolveLoginCompany(companyList) {
  const activeCompanies = (companyList || []).filter((company) => company.status);
  if (!activeCompanies.length) {
    return null;
  }

  const configuredCompanyId = (process.env.REACT_APP_LOGIN_COMPANY_ID || '').trim();
  if (configuredCompanyId) {
    const companyById = activeCompanies.find(
      (company) => String(company.id) === configuredCompanyId,
    );
    if (companyById) {
      return companyById;
    }
  }

  const needle = LOGIN_COMPANY_MATCH_TEXT.toLowerCase();
  const needles = [needle, 'litvik', LOGIN_COMPANY_DISPLAY_NAME.toLowerCase()].filter(Boolean);
  const companyByName = activeCompanies.find((company) => {
    const name = (company.name || '').toLowerCase();
    const alias = (company.alias || '').toLowerCase();
    return needles.some((n) => name.includes(n) || alias.includes(n));
  });
  if (companyByName) {
    return companyByName;
  }

  return null;
}

export function getCompanyMediaUrl(apiBaseUrl, mediaPath) {
  if (!mediaPath) {
    return '';
  }
  if (/^https?:\/\//i.test(mediaPath)) {
    return mediaPath;
  }
  const origin = apiBaseUrl.replace(/\/api\/?$/, '');
  return `${origin}${mediaPath.startsWith('/') ? '' : '/'}${mediaPath}`;
}
